import { DocumentTypeEnum } from "../applications/CreditApplication";

export class SoulDataModel {
  fullName?: string;
  role?: string;
  documentType?: DocumentTypeEnum;
  document?: string;
  address?: string;
  emailOptional?: string;
  birthDate?: string;
  docPhotoURL?: string;
  selfiePhotoURL?: string;
  isVerified?: boolean;
  userId?: string;
  isGuarantor?: boolean;

  constructor(data: any) {
    this.fullName = data?.fullName || "Anónimo";
    this.role = data?.role;
    this.documentType = data?.documentType;
    this.document = data?.document;
    this.address = data?.address;
    this.emailOptional = data?.emailOptional;
    this.birthDate = data?.birthDate;
    this.docPhotoURL = data?.docPhotoURL;
    this.selfiePhotoURL = data?.selfiePhotoURL;
    this.isVerified = data?.isVerified ?? false;
    this.userId = data?.userId;
    this.isGuarantor = data?.isGuarantor ?? false;
  }
}

export class UpdateSoulInfoPayload {
  payload: SoulDataModel;

  constructor(payload: SoulDataModel) {
    this.payload = payload;
  }
}
